import React from 'react';
import BoschIcon from './BoschIcon.js';
const ContactTeaserContactType = ({
  icon = null,
  protocol,
  contactData
}) => {
  const propertyIcon = icon ? /*#__PURE__*/React.createElement(BoschIcon, {
    icon: icon,
    srText: ""
  }) : null;
  const schema = protocol === 'mail' ? 'mailto:' : 'tel:';
  const href = `${schema}${contactData}`;
  return /*#__PURE__*/React.createElement("div", {
    className: "ebds-contact-teaser__contact-type"
  }, /*#__PURE__*/React.createElement("a", {
    className: "ebds-contact-teaser__contact-type__data",
    href: href
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-contact-teaser__contact-type__data__icon"
  }, propertyIcon), contactData));
};
export default ContactTeaserContactType;